<template>
    <div id="wrapper" class="page" v-if="salary_read">
      <div id="content-wrapper">
        <div class="container-fluid">
          <span style="display: inline;">
            <button class="btn btn-success mb-2 ml-2" @click.prevent="excelReport()">
              <i class="far fa-file-excel"></i>
              Export to Excel
              <!-- Xuất Excel -->
            </button>
          </span>
          <span style="display: inline;">
            <!-- <div style="text-align:center;">
            Thời hạn
            <b-form-select  class="mb-2 ml-2" v-model="duration_selected" style="width: 10%" :options="optionsDuration" value-field="value" text-field="text" @change="queryItem"/>
            <button class="btn btn-success mb-2 ml-2" @click.prevent="excelReport">
              <i class="far fa-file-excel"></i> Xuất excel
            </button>
            </div> -->
            <!-- <b-form-select  v-model="month_selected" class="mb-2 mr-2" style="width: 10%" :options="optionsMonth" value-field="value" text-field="text" @change="queryItem"/> -->
            <div class="form-inline" style="width: 100%">
              <b-form-input class="mb-2"
                  style="flex-grow: 1"
                  v-model="query"
                  placeholder="Filter by employee code, name"
                  @keydown.enter.prevent="queryItem"
                  >
              </b-form-input>
              <button class="btn" id="popover-target-1">
                <i class="fas fa-filter"></i>
              </button>
            </div>
          </span>
          <b-popover target="popover-target-1" triggers="click blur">
                <template v-slot:title>
                  Filter by time
                  <!-- Lọc theo thời hạn -->
                </template>
                <b-form-select
                  v-model="duration_selected"
                  :options="optionsDuration"
                  value-field="value"
                  text-field="text" @change="queryItem"
                >
                </b-form-select>
                <!-- <b-form-select
                  v-model="employeeStatus"
                  :options="tinhtranghosos"
                  value-field="id"
                  text-field="pickListValue"
                  @change="filterEmployee"
                >
                  <template v-slot:first>
                    <b-form-select-option value="-1"
                      >Tất cả</b-form-select-option
                    >
                  </template>
                </b-form-select> -->
              </b-popover>


          <b-table
          bordered
          head-variant="dark"
          hover
          responsive
          striped
          small
          table-variant="light"
          :fields="fields"
          :items="histories"
          selectable
          select-mode="single"
          @row-clicked="onRowClicked"
          >
            <template slot="row-details">
              <b-card>
                <b-table
                  bordered
                  head-variant="dark"
                  hover
                  responsive
                  striped
                  small
                  table-variant="light"
                  :fields="detailFields"
                  :items="detail_histories"
                >
                  <template v-slot:cell(thuongduan)="data">
                    <div v-if="data.item.thuongduanusd != 0 && data.item.thuongduanusd != null">{{data.item.thuongduanusd | numeral('0,0') }} USD</div>
                    <div v-if="data.item.thuongduanvnd != 0 && data.item.thuongduanvnd != null">{{data.item.thuongduanvnd | numeral('0,0') }} VNĐ</div>
                  </template>
                  <template v-slot:cell(ngayhieuluc)="data">{{data.item.ngayhieuluc.substr(5, 2) + "/" + data.item.ngayhieuluc.substr(0, 4)}}</template>
                  <template v-slot:cell(ngayhethan)="data">{{data.item.ngayhethan != null ? data.item.ngayhethan.substr(5, 2) + "/" + data.item.ngayhethan.substr(0, 4): ""}}</template>
                  <template v-slot:cell(luonghientai)="data">{{data.item.luonghientai | numeral('0,0')}}</template>
                  <template v-slot:cell(tyletang)="data">{{data.item.tyletang + "%"}}</template>
                </b-table>
              </b-card>
            </template>
            <template v-slot:cell(chucdanh)="data">{{data.item.chucdanh == null ? "" : findPickList(chucdanhs, data.item.chucdanh)}}</template>
            <template v-slot:cell(luonghientai)="data">
              <div v-if="data.item.luonghientai != 0">
                {{data.item.luonghientai | numeral('0,0')}}
              </div>
            </template>
            <template v-slot:cell(thuongduan)="data">
              <div v-if="data.item.thuongduanusd != 0 && data.item.thuongduanusd != null">{{data.item.thuongduanusd | numeral('0,0') }} USD</div>
              <div v-if="data.item.thuongduanvnd != 0 && data.item.thuongduanvnd != null">{{data.item.thuongduanvnd | numeral('0,0') }} VND</div>
            </template>
            <template v-slot:cell(ngayhieuluc)="data">{{data.item.ngayhieuluc.substr(5, 2) + "/" + data.item.ngayhieuluc.substr(0, 4)}}</template>
            <!-- @Edit Thanh
            <template v-slot:cell(mucluongcu)="data">{{data.item.mucluongcu | numeral('0,0')}}</template>
            <template v-slot:cell(tyletang)="data">
              <span v-show="data.item.tyletang!=0">
                {{data.item.tyletang + "%"}}
              </span>
            </template> -->
          </b-table>
        </div>
      </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
  name: "SalariesHistory",
  data() {
    return {
      fields: [
        {
          key: "manhanvien",
          label: "Code",
          // label: "Mã NV",
          thClass: "align-middle",
          thStyle: { textAlign : "center" },
        },
        {
          key: "hovaten",
          label: "Name",
          // label: "Họ và tên",
          thClass: "align-middle",
          thStyle: { textAlign : "center" },
        },
        {
          key: "chucdanh",
          label: "Position",
          // label: "Chức danh",
          thClass: "align-middle",
          thStyle: { textAlign : "center" },
        },
        {
          key: "luonghientai",
          label: "Current Salary",
          // label: "Lương hiện tại",
          thClass: "align-middle",
          thStyle: { textAlign : "center" },
          tdClass: "text-right",
        },
        {
          key: "thuongduan",
          label: "Bonus",
          // label: "Thưởng dự án",
          thClass: "align-middle",
          thStyle: { textAlign : "center" },
          tdClass: "text-right",
        },
        {
          key: "ngayhieuluc",
          label: "Effective date",
          // label: "Hiệu lực",
          thClass: "align-middle",
          thStyle: { textAlign : "center" },
          tdClass: "text-center",
        },
        // @Edit Thanh
        // {
        //   key: "mucluongcu",
        //   label: "Mức lương cũ",
        //   thClass: "align-middle",
        //   thStyle: { textAlign : "center" },
        //   tdClass: "text-right",
        // },
        // {
        //   key: "tyletang",
        //   label: "Tỷ lệ tăng",
        //   thClass: "align-middle",
        //   thStyle: { textAlign : "center" },
        //   tdClass: "text-right",
        // },
        {
          key: "thoihan",
          label: "Duration",
          // label: "Thời hạn",
          thClass: "align-middle",
          thStyle: { textAlign : "center" },
        },
      ],
      detailFields: [
        {
          key: "sohopdong",
          label: "Contract ID",
          // label: "Số hợp đồng",
          thClass: "align-middle",
          thStyle: { textAlign : "center" },
        },
        {
          key: "ngayhieuluc",
          label: "Valid date",
          // label: "Ngày hiệu lực",
          thClass: "align-middle",
          thStyle: { textAlign : "center" },
          tdClass: "text-center",
        },
        {
          key: "ngayhethan",
          label: "Expiry Date",
          // label: "Ngày hết hạn",
          thClass: "align-middle",
          thStyle: { textAlign : "center" },
          tdClass: "text-center",
        },
        {
          key: "luonghientai",
          label: "Current Salary",
          // label: "Lương",
          thClass: "align-middle",
          thStyle: { textAlign : "center" },
          tdClass: "text-right",
        },
        {
          key: "thuongduan",
          label: "Bonus",
          // label: "Thưởng dự án",
          thClass: "align-middle",
          thStyle: { textAlign : "center" },
          tdClass: "text-right",
        },
        {
          key: "tyletang",
          label: "Rate of increase",
          // label: "Tỷ lệ tăng",
          thClass: "align-middle",
          thStyle: { textAlign : "center" },
          tdClass: "text-right",
        },
      ],

      query: null,
      departments: [],
      histories: [],
      detail_histories: [],
      full_histories: [],
      chucdanhs: [],
      old_row: null,

      duration_selected: 0,
      optionsDuration: [{value: "0", text: "All"},
                        {value: "6", text: "> 6 months"},
                        {value: "12", text: "> 1 year"},
                        {value: "18", text: "> 1.5 years"},
                        {value: "24", text: "> 2 years"}]
    }
  },
  computed: {
    salary_read() {
      return this.$store.getters.hasPermission("salary_read");
    },
    optionsYear() {
      var result = [];
      var this_year = new Date().getFullYear();
      for (var i = 2020; i <= this_year; ++i) {result.push({value: i, text: i});}
      return result;
    },
    is_all_department() {
      return this.$store.state.auth.i == 0;
    }
  },
  beforeRouteEnter(to, from, next) {
      axios
      .all([
          axios.get("/api/salary/salary_history"),
          axios.get("/api/picklist?q=vitricongviec")
      ])
      .then(
          axios.spread((history, chucdanh)=> {
              next((vm) => vm.initData(history.data.distinct_items, history.data.items, chucdanh.data));
          })
      );
  },
  methods:{
    initData(histories, full_histories, chucdanhs) {
      this.histories = histories;
      this.full_histories = full_histories;
      this.chucdanhs = chucdanhs;

      this.full_histories.push({empcontractid: -1}); // Padded null item for finding old salary f-kery!!!

      var current_year = new Date().getFullYear();
      var current_month = parseInt(new Date().getMonth() + 1);
      // Populate Muc luong cu, Ty le tang, Thoi han
      for (var history of this.histories) {
        history.mucluongcu = this.findOldSalary(history.empcontractid);
        if (history.luonghientai > 0) history.tyletang = parseFloat((history.luonghientai - history.mucluongcu) * 100/ history.mucluongcu).toFixed(2);
        if (history.tyletang == 100) history.tyletang = 0;

        var hieuluc_year = new Date(history.ngayhieuluc).getFullYear();
        var hieuluc_month = parseInt(new Date(history.ngayhieuluc).getMonth() + 1);

        if (current_year == hieuluc_year) history.thoihan = current_month - hieuluc_month + " tháng";
        if (current_year > hieuluc_year && current_month < hieuluc_month) {
          if (current_year - hieuluc_year == 1) history.thoihan = current_month - hieuluc_month + 12 + " tháng";
          else history.thoihan = (current_year - hieuluc_year) - 1 + " năm " + (current_month - hieuluc_month + 12) + " tháng";
        }
        if (current_year > hieuluc_year && current_month == hieuluc_month) history.thoihan = current_year - hieuluc_year + " năm";
        if (current_year > hieuluc_year && current_month > hieuluc_month) history.thoihan = (current_year - hieuluc_year) + " năm " + (current_month - hieuluc_month) + " tháng";
      }
    },
    // excelReport(year, month, departmentid) {
    //   let query = Object.assign({}, this.$route.query);
    //   query.year = year;
    //   query.month = month;
    //   query.depid = departmentid;
    //   axios({
    //     method: "get",
    //     url: `/api/salary/report4`,
    //     params: query,
    //     responseType: "blob", // important
    //   })
    //     .then((res) => {
    //       let filename = res.headers["content-disposition"]
    //         .split(";")
    //         .find(function(el) {
    //           if (el.includes("filename=")) return el;
    //         })
    //         .replace("filename=", "")
    //         .trim();
    //       const url = window.URL.createObjectURL(
    //         new Blob([res.data], {
    //           type: "application/vnd.ms-excel;charset=utf-8",
    //         })
    //       );
    //       const link = document.createElement("a");
    //       link.href = url;
    //       link.setAttribute("download", filename); //or any other extension
    //       document.body.appendChild(link);
    //       link.click();
    //     })
    //     .catch((err) => {
    //       //   reject(err);
    //     });
    // },

  excelReport() {
      let query = Object.assign({}, this.$route.query);
      query.report = 12;//History
      // Parameter for report
      axios({
        method: "get",
        url: `/api/employeereport/report`,
        params: query,
        responseType: "blob", // important
      })
        .then((res) => {
          let filename = res.headers["content-disposition"]
            .split(";")
            .find(function(el) {
              if (el.includes("filename=")) return el;
            })
            .replace("filename=", "")
            .trim();
          const url = window.URL.createObjectURL(
            new Blob([res.data], {
              type: "application/vnd.ms-excel;charset=utf-8",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {
          //   reject(err);
        });
    },

    queryItem() {
      let query = Object.assign({}, this.$route.query);
      query.q = this.query;
      query.duration = this.duration_selected;

      axios.get("/api/salary/salary_history", {params: query})
      .then((res) => {this.initData(res.data.distinct_items, res.data.items, this.chucdanhs);});
    },
    findPickList(list, id) {
      const temp = list.find(function (el) {
        if (el.empcontractid == id) return el;
      });
      return temp == null ? "" : temp.pickListValue;
    },
    findFirstDepartment(list, id) {
      const temp = list.find(function(el) {
        if (el.empcontractid == id) return el;
      });
      return temp == null ? "" : temp.tendonvi;
    },
    findFirstDepartmentShort(list, id) {
      const temp = list.find(function(el) {
        if (el.empcontractid == id) return el;
      });
      return temp == null ? "" : temp.madonvi;
    },
    formatDate(date) {
      return date.substr(5, 2) + "/" + date.substr(0, 4);
    },
    findOldSalary(id) {
      var current_salary = this.full_histories.find(x => x.empcontractid == id);
      var current_salary_index = this.full_histories.indexOf(current_salary);
      var old_salary = this.full_histories[current_salary_index + 1];

      if (current_salary.manhanvien == old_salary.manhanvien) return old_salary.luonghientai;

      return 0;
    },
    onRowClicked(row) {
      row._showDetails = !row._showDetails;

      if (this.old_row != null && this.old_row != row) this.old_row._showDetails = false;
      this.old_row = row;

      this.detail_histories = this.full_histories.filter(x => x.manhanvien == row.manhanvien);
      for (var history of this.detail_histories) {
        var curr_index = this.detail_histories.indexOf(history);
        if (curr_index == this.detail_histories.length - 1) break;
        history.mucluongcu = this.detail_histories[curr_index + 1].luonghientai;

        if (history.luonghientai > 0) history.tyletang = parseFloat((history.luonghientai - history.mucluongcu) * 100/ history.mucluongcu).toFixed(2);
        if (history.tyletang == 100) history.tyletang = 0;
      }
    },
  },
}
</script>
